import { FunctionComponent } from "react";

export const Spacer: FunctionComponent = () => (
    <div style={{ margin: 8 }} />
);
